import React from "react";

const ThankUMessage = ({
  setShow,
  changeEmailMessage,
  changeCouponValidationMessage,
  childcareMessage,
  isTrial,
  match,
}) => {
  return (
    <div className="example example-compact">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
            minHeight: '1000px'
          }}

        >
          <h2>Thank you & great choice!</h2>
          <hr />
          <h6
            style={{
              fontSize: "14px",
              fontWeight: "normal",
              lineHeight: "1.6",
            }}
          >
            Thanks for your booking. We've emailed you the details.
            {childcareMessage && (
              <div
                dangerouslySetInnerHTML={{
                  __html: childcareMessage,
                }}
              />
            )}
          </h6>
          <br />
          <h6>Kind regards,</h6>
          <h6>
            from the{" "}
            {match.params.business === "ginger"
              ? "Ginger Sport Team"
              : "Quest FA Team"}
          </h6>
          <h6
            style={{
              fontSize: "14px",
              fontWeight: "normal",
              lineHeight: "1.6",
            }}
          >
            {isTrial ? (
              <span
                style={{ color: "#3699FF", cursor: "pointer" }}
                onClick={() => {
                  setShow(false);
                  changeEmailMessage();
                }}
              >
                Book a trial session for another child
              </span>
            ) : (
              <span
                style={{ color: "#3699FF", cursor: "pointer" }}
                onClick={() => {
                  setShow(false);
                  changeEmailMessage();
                  changeCouponValidationMessage();
                }}
              >
                Enrol another child
              </span>
            )}
          </h6>
          <hr />
        </div>
      </div>
    </div>
  );
};

export default ThankUMessage;
